import { isSSR } from '@k2/core/util'
import type { NavigationGuardWithThis, RouteLocationRaw } from 'vue-router'
import { useProfileStore } from '@/auth'
import { useOrganizationStore } from '../store'

// Nothing to pick when there is one (FR-A3 always creates it), except for an admin, whose way into `/admin` is the picker (FR-A14); zero stays on the picker.
export const singleOrganizationGuard: NavigationGuardWithThis<undefined> = async () => {
  if (isSSR) return true

  const store = useOrganizationStore()
  const profile = useProfileStore()
  await Promise.all([store.load(), profile.load()])

  const [only] = store.organizations
  if (store.organizations.length !== 1 || !only || profile.profile?.isAdmin) return true

  return { name: 'dashboard', params: { organizationId: only.id } } as RouteLocationRaw
}
